import moment from 'moment';

export function formatDuration(duration) {
  return moment.utc(duration * 1000).format('HH:mm:ss', { trim: false });
}
